/**
 * Reconnexion après un 401 `REAUTH_REQUIRED` (geste irréversible sur une connexion trop
 * ancienne — suppression d'organisation ou de projet). Partagé par les dialogues de suppression.
 *
 * En mode porteur (`ciamConfigured`), un renouvellement silencieux ne rajeunit pas `auth_time` :
 * seule une interaction le fait, d'où `prompt: 'login'`. Sans CIAM (coexistence D7), repli
 * legacy sur le fournisseur de la session ; `local` (bypass dev) ou un fournisseur inconnu n'ont
 * pas de flux OAuth à relancer → `/connexion`.
 */

import { API_BASE } from './api.js';
import { ciamConfigured, login as authLogin } from './auth.js';

/** Fournisseurs qui portent réellement un flux OAuth relançable (miroir de `lib/connexion.js`). */
const OAUTH_PROVIDERS = new Set(['microsoft', 'google', 'github']);

/**
 * @param {string} returnTo Chemin où revenir après la reconnexion.
 * @param {{ provider?: string } | null | undefined} user Session courante.
 */
export function reconnectForReauth(returnTo, user) {
  if (ciamConfigured) {
    authLogin(returnTo, { prompt: 'login' });
    return;
  }
  const provider = user?.provider;
  if (!OAUTH_PROVIDERS.has(provider)) {
    window.location.assign('/connexion');
    return;
  }
  window.location.assign(
    `${API_BASE}/api/auth/${provider}/start?returnTo=${encodeURIComponent(returnTo)}`,
  );
}
